import { Component, Input } from '@angular/core';
import { Spettacolo } from '../../shared/interface';

@Component({
  selector: 'app-spettacolo-box',
  templateUrl: './spettacolo-box.component.html',
  styleUrl: './spettacolo-box.component.css'
})
export class SpettacoloBoxComponent {

  constructor() { }

  @Input() spettacolo?: Spettacolo;
  @Input() spettacolo_button: boolean = true;
  @Input() spettacolo_width: string = 'lg:w-[40%]';
  @Input() immagine_width: string = 'lg:w-[60%]';  

  spettacoloUrl(spettacolo: string | undefined, dal: string | undefined, al: string | undefined): string {      

    let spettacoloUrl = encodeURIComponent(this.toTitleCase(spettacolo!.replace(/[^a-zA-Z0-9 ]/g, '-').toLowerCase()).replace(/ /g, '-'));

    let startDate = new Date(dal!).toISOString().split('T')[0];
    let endDate = new Date(al!).toISOString().split('T')[0];

    return `${startDate}/${endDate}/${spettacoloUrl}`;
  }

  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

}
